module.exports = new __parcel__URL__("cog-illustration.e5af7243.png").toString();